import React, { useEffect, useRef } from 'react';
import cls from './Option.module.css';
import classNames from 'classnames';

export const Option = ({ option, onClick, setIsOpen }) => {
    const optionRef = useRef(null);
    const handleClick = (clickedValue, event) => {
        if (!option.isDisabled) {
            if (option.isButton) {
                option.buttonHandler();
            } else {
                onClick(clickedValue);
                setIsOpen(false);
            }
        } else {
            event.stopPropagation();
        }
    };

    useEffect(() => {
        const option = optionRef.current;
        if (!option) return;

        const handleEnterPress = (event) => {
            if (document.activeElement === option && event.key === 'Enter') {
                onClick(option.value);
            }
        };

        option.addEventListener('keydown', handleEnterPress);

        return () => {
            option.removeEventListener('keydown', handleEnterPress);
        };
    }, [option.value, onClick]);
    const [float, kopecks] = String(option.startBalance).split('.');
    return (
        <li
            ref={optionRef}
            className={classNames(cls.option, {
                [cls.disabledOption]: option.isDisabled,
            })}
            value={option.value}
            onClick={(e) => handleClick(option.value, e)}
            tabIndex={0}
        >
            <span>{option.shortNumber}</span>
            <span className={classNames(cls.balance)}>
                {float},<span className={classNames(cls.kopecks)}>{kopecks ? kopecks : '00'}</span>
            </span>
        </li>
    );
};
